import { render } from "./HistoricalEntitlementUsageCharts.vue?vue&type=template&id=25ef612c&scoped=true"
import script from "./HistoricalEntitlementUsageCharts.vue?vue&type=script&lang=js"
export * from "./HistoricalEntitlementUsageCharts.vue?vue&type=script&lang=js"

import "./HistoricalEntitlementUsageCharts.vue?vue&type=style&index=0&id=25ef612c&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25ef612c"]])

export default __exports__